export type TalentType = {
  id: number
  _id: string
  name: string
  email: string
  phone: string
  position: string
  level: string
  skills: string[]
  languages: { language: string, level: number }[]
  education: string[]
  experience: string[]
  status: string
  lastUpdated: string
  updatedAt: string
  location?: string
  availability?: string
  salary?: string
  resumeUrl?: string
  portfolioUrl?: string
  linkedInUrl?: string
  githubUrl?: string
  notes?: string
}

export type FilterType = {
  level: string
  status: string
  skills: string[]
  languages: string[]
  location?: string
  availability?: string
  dateRange?: {
    start: string
    end: string
  }
}

export type ViewMode = "grid" | "list" 

export type CandidateStatus =
  | "010 Open"
  | "020 Submitted"
  | "030 Internal Interviewed"
  | "040 Failed"
  | "041 Passed"
  | "050 Client Interviewing"
  | "051 Client Interviewed"
  | "060 Negotiating"
  | "070 Offer Sent"
  | "071 CAN Reject"
  | "071 CAN Accepted"
  | "080 Onboarded"
  | "090 Pending"
  | "091 Keep Contact"
  | "100 Cancelled"
  | "021 Interview Cancelled"
  | "022 CV Rejected"

export const CandidateStatusMap: Record<string, string> = {
  "010": "Open",
  "020": "Submitted",
  "030": "Internal Interviewed",
  "040": "Failed",
  "041": "Passed",
  "050": "Client Interviewing",
  "051": "Client Interviewed",
  "060": "Negotiating",
  "070": "Offer Sent",
  "071": "CAN Reject",
  "072": "CAN Accepted",
  "080": "Onboarded",
  "090": "Pending",
  "091": "Keep Contact",
  "100": "Cancelled",
  "021": "Interview Cancelled",
  "022": "CV Rejected"
}
